import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';
import { isEmpty } from '@/utils/basic';

export default {
  data() {
    return {};
  },
  computed: {
    /**
     * 현재 View 모드를 반환한다.
     * @author KangBonghun(toto1323)
     * @return {String} monitoring || edit || slideshow
     */
    viewMode() {
      return this.$store.getters.getTopologymapViewMode;
    },
    /**
     * 현재 맵 아이디를 반환한다.
     * @author KangBonghun(toto1323)
     * @return {Number} 현재 맵 아이디
     */
    currentMapId() {
      return this.$store.getters.getCurrentMapId;
    },
    /**
     * 맵 트리에서 현재 선택 된 노드를 반환한다.
     * @author KangBonghun(toto1323)
     * @return {Object} 현재 선택 된 맵 트리 노드
     */
    mapTreeSelectedNode() {
      return this.$store.getters.selectedNode;
    },
    /**
     * 현재 View 모드가 편집모드인지 반환한다.
     * @author KangBonghun(toto1323)
     * @return {Boolean} 편집 모드 여부
     */
    isEditMode() {
      return this.viewMode === MapConst.VIEW_MODE.EDIT;
    },
    /**
     * 현재 트리 편집 모드 여부
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isTreeEditMode() {
      return this.viewMode === MapConst.VIEW_MODE.TREE_EDIT;
    },
    getUserInfo() {
      return this.$store.getters.userInfo;
    },

    isSettingAuth() {
      return this.getUserInfo && this.getUserInfo.managerType === 'ADMIN';
    },

    isFullScreen() {
      return this.$store.getters.isFullScreen;
    },
    isTimelineExpand() {
      return this.$store.getters.isTimelineExpand;
    },
    isInDashboardWidget() {
      return this.$store.getters.getRefreshOptions && this.$store.getters.getRefreshOptions.toolbar === false;
    },
    isMapTreeCollapse() {
      return this.$store.getters.isMapTreeCollapse;
    },
    isAutomapDeviceTableExpand() {
      return this.$store.getters.isAutomapDeviceTableExpand;
    },
    automapInfo() {
      return this.$store.getters.getAutomapInfo;
    },
    isAutomap() {
      return !isEmpty(this.automapInfo);
    },
    isCustomChanged() {
      return this.automapInfo && this.automapInfo.schedule.customChngDatetime;
    },
  },
  methods: {
    /**
     * 특정 맵으로 라우팅을 변경한다.
     * @author KangBonghun(toto1323)
     * @param  {Number} mapId  맵 아이디
     * @param  {Object} params 전달 할 데이터
     */
    routeMap(mapId, params) {
      if (this.currentMapId === mapId) {
        this.$message.info('현재 맵과 동일한 맵입니다.');
        return;
      }

      this.$router.push({
        path: `/topologymap/${mapId}`,
        query: params,
      });
    },
    /**
     * 맵 트리를 로드한다.
     * @author KangBonghun(toto1323)
     */
    treeLoad() {
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.TREE_LOAD);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/topologymap/base.js